import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(/* webpackChunkName: "business-products-ai-shade-finder" */ './index')
);

export default prerenderedLoadable(Page);
